import { render, staticRenderFns } from "./ExchangeOrderTables.html?vue&type=template&id=29622459&scoped=true&"
import script from "./ExchangeOrderTables.js?vue&type=script&lang=js&"
export * from "./ExchangeOrderTables.js?vue&type=script&lang=js&"
import style0 from "./ExchangeOrderTables.scss?vue&type=style&index=0&id=29622459&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29622459",
  null
  
)

export default component.exports